import { render, staticRenderFns } from "./EmbeddedCrudTable.vue?vue&type=template&id=3f6c4039&scoped=true"
import script from "./EmbeddedCrudTable.vue?vue&type=script&lang=js"
export * from "./EmbeddedCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c4039",
  null
  
)

export default component.exports